/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSouscriptionPaymentRefundMutation($input: SaveSouscriptionPaymentRefund_M_souscription_payment_refundInput!) {
    saveSouscriptionPaymentRefund_M_souscription_payment_refund(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
